import React from 'react'
import classNames from 'classnames'

import './style.scss'

class GridItem extends React.Component {
  onMouseLeave(event) {
    const currentItemGrid = event.currentTarget.parentNode

    window.requestAnimationFrame(function animation() {
      currentItemGrid.style.transform = null

      window.requestAnimationFrame(animation)
    })
  }

  render() {
    const checkingFileExistence = (id) => {
      try {
        return require('../../assets/images/facts/' + id + '/mini.png')
      } catch (err) {
        return null
      }
    }

    let tag = this.props.factsTags.filter((obj) => {
      return obj.id === this.props.item.tag
    })[0].name

    tag = tag.replace('#', '')
    tag = tag.charAt(0).toUpperCase() + tag.slice(1)

    return (
      <div
        className={classNames('item', {'quiz-item' : this.props.gridQuiz})}
        onClick={() => this.props.openModal('fact', this.props.item.id)}
      >
        {
          checkingFileExistence(this.props.item.id) ? (
            <div
              className={classNames('image-background', {'filled-background' : this.props.item.background})}
              style={{backgroundImage: 'url(' + require(`../../assets/images/facts/${this.props.item.id}/mini.png`) + ')'}}
              onMouseMove={this.props.onMouseMove}
              onMouseLeave={this.onMouseLeave}
            />
          ) : (
            <div className="stub">
              <div className="stub-id">{this.props.item.id}</div>
              <div className="stub-tag" dangerouslySetInnerHTML={{ __html: tag }}/>
            </div>
          )
        }
      </div>
    )
  }
}

export default GridItem
